import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import OrganizationDomain from 'domain/organization';
import { getHistory } from 'api/organization';
import ManagerDomain from 'domain/manager';

export const useOrganizationEdit = () => {
  const { orgCode } = useParams<{orgCode: string}>();
  const [organizationDomain, setOrganizationDomain] = useState<OrganizationDomain>(
    OrganizationDomain.generateInitial(),
  );
  const [managerList, setManagerList] = useState<Array<ManagerDomain>|null>(null);
  const [seniorManagerList, setSeniorManagerList] = useState<Array<ManagerDomain>|null>(null);
  const [historyList, setHistoryList] = useState<Array<OrganizationDomain>>([]);
  const [blocking, setBlocking] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setBlocking(true);
      const history = await getHistory(orgCode);
      const organization = history[0];
      setOrganizationDomain(new OrganizationDomain(organization));
      if (organization.managerList && organization.managerList.length > 0) {
        setManagerList(organization.managerList.map((manager) => new ManagerDomain(manager)));
      } else {
        setManagerList([]);
      }
      if (organization.seniorManagerList && organization.seniorManagerList.length > 0) {
        setSeniorManagerList(organization.seniorManagerList.map(
          (seniorManager) => new ManagerDomain(seniorManager),
        ));
      } else {
        setSeniorManagerList([]);
      }
      if (history && history.length > 0) {
        setHistoryList(history.map((org) => new OrganizationDomain(org)));
      } else {
        setHistoryList([]);
      }
      setBlocking(false);
    };
    fetchData();
  }, [orgCode]);

  return {
    organizationDomain,
    setOrganizationDomain,
    managerList,
    setManagerList,
    seniorManagerList,
    setSeniorManagerList,
    historyList,
    setHistoryList,
    blocking,
    orgCode
  };
};

export default {};
